import type { FeatureModule } from "@/app";
import { AccueilPage } from "./screens/AccueilPage";
import { DossierIntakePage } from "./screens/DossierIntakePage";
import { DemandeNewPage } from "./screens/DemandeNewPage";
import { DemandeWorkspacePage } from "./screens/DemandeWorkspacePage";
import { registerReceptionMessages } from "./lib/messages";
import { CAPS } from "./lib/caps";

/**
 * Reception (accueil) FeatureModule — patient/dossier intake with live dedup, demande creation, Rx-QR
 * scan, tube generation, the billing handoff, and connection-link invites.
 *
 * The whole module gates on `reception.dossier.read` (the minimum to reach the front desk). Every
 * mutating action gates TIGHTER, per-action, via useCan inside the screens (server re-checks each
 * request — these only hide/show UI). Routes are mounted under the AppShell and auto-wrapped in
 * <ProtectedRoute requiredCapabilities={requiredCapabilities}> + <ErrorBoundary> by the router.
 */
const receptionModule: FeatureModule = {
  id: "reception",
  title: "Réception",
  requiredCapabilities: [CAPS.dossierRead],
  routes: [
    { path: "/reception", element: <AccueilPage /> },
    { path: "/reception/dossiers/nouveau", element: <DossierIntakePage /> },
    { path: "/reception/demandes/nouvelle", element: <DemandeNewPage /> },
    { path: "/reception/demandes/:id", element: <DemandeWorkspacePage /> },
  ],
  nav: [
    {
      id: "reception",
      path: "/reception",
      label: "nav.reception",
      icon: "▤",
      order: 20,
      section: "nav.section.production",
    },
  ],
  onRegister() {
    registerReceptionMessages();
  },
};

export default receptionModule;
